import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import DepartmentsWrapper from "./routes/DepartmentsWrapper";

export default store => ({
  path: "academic-year-transition-v2",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "academic-year-transition" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [DepartmentsWrapper(store)],
});
